import { Component, OnInit } from '@angular/core';


import { BusquedasService } from '../../services/busquedas.service';

import { User } from 'src/app/models/user.model';

import { AreaModel } from '../../models/area.model';
import { EmployeeModel } from '../../models/employee.model';
import { SubAreaModel } from '../../models/subarea.model';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-busqueda',
    templateUrl: './busqueda.component.html',
    styles: [],
    standalone: false
})
export class BusquedaComponent implements OnInit {

  public usuarios: User[] = [];
  public empleados: EmployeeModel[] = [];
  public areas: AreaModel[] = [];
  public subareas: SubAreaModel[] = [];


constructor( private activatedRoute: ActivatedRoute,
             private busquedasService: BusquedasService ) { }

ngOnInit(): void {
  this.activatedRoute.params
                  .subscribe( ({ termino }) =>  this.busquedaGlobal(termino));
}


busquedaGlobal( termino: string ) {

this.busquedasService.busquedaGlobal( termino )
                      .subscribe( (resp: any) => {
                        this.usuarios = resp.users;
                        this.empleados = resp.employees;
                        this.areas = resp.areas;
                        this.subareas = resp.subareas;
                      });

}

}
